import PerfectScrollbar from 'perfect-scrollbar';

export const Scroll = () => {
  if ($('div').is('.js-perfect-scroll'))
    new PerfectScrollbar('.js-perfect-scroll');
};
